export default __webpack_public_path__ + "static/media/crateio.8b6c88dc.svg";